import { useSetAtom } from "jotai";
import { Icon } from "@zapier/zinnia-icons";
import {
  BetaMenuTriggerPopover,
  BetaMenuTriggerList,
  BetaMenuTriggerItem,
} from "@zapier/design-system";
import { nodesAtom } from "@zapier/canvas-state";
import { useReactFlow } from "@xyflow/react";
import { uuid } from "@zapier/canvas-state/src/utils";
import styles from "./MoreMenu.module.css";

const EMBED_LINK_LABEL = "Embed link";

export function MoreMenu() {
  const setNodes = useSetAtom(nodesAtom);
  const { getViewport } = useReactFlow();

  const createEphemeralEmbedNode = () => {
    const viewport = getViewport();
    const centerX = (viewport.x * -1 + window.innerWidth / 2) / viewport.zoom;
    const centerY = (viewport.y * -1 + window.innerHeight / 2) / viewport.zoom;

    const ephemeralNode = {
      id: uuid(),
      type: "embed-ephemeral" as const,
      position: {
        x: centerX - 210,
        y: centerY - 140,
      },
      data: {},
      selected: true,
    };

    setNodes((nodes) => [
      ...nodes.map((node) => ({ ...node, selected: false })),
      ephemeralNode,
    ]);
  };

  return (
    <BetaMenuTriggerPopover>
      <BetaMenuTriggerList
        onAction={(key) => {
          if (key === "embed-link") createEphemeralEmbedNode();
        }}
      >
        <BetaMenuTriggerItem id="embed-link">
          <div className={styles.row}>
            <Icon name="fileAdd" color="StrokeStronger" size={20} />
            <span>{EMBED_LINK_LABEL}</span>
          </div>
        </BetaMenuTriggerItem>
      </BetaMenuTriggerList>
    </BetaMenuTriggerPopover>
  );
}
